import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function BaseNewDropDown({ label, options, values, onChange, withCheckboxes = false }) {
  const [selectedValues, setSelectedValues] = React.useState(values || []);

  React.useEffect(() => {
    setSelectedValues(values || []);
  }, [values]);

  const handleChange = (event) => {
    const newValues = event.target.value;
    setSelectedValues(newValues);
    if (onChange) {
      onChange(newValues);
    }
  };

  return (
    <div>
      <FormControl
        variant="standard"
        sx={{
          m: 1,
          minWidth: 220,
          margin: 0,
          minHeight: '50px',
          display: 'grid',
          width: '100%',
        }}
      >
        {selectedValues.length === 0 && (
          <InputLabel shrink={false} sx={{ fontSize: '14px' }}>
            {label}
          </InputLabel>
        )}
        <Select
          multiple
          value={selectedValues}
          onChange={handleChange}
          IconComponent={KeyboardArrowDownIcon}
          renderValue={(selected) => selected.join(', ')}
          sx={{
            fontSize: '14px',
            marginTop: '16px',
            opacity: '0.9',
            maxWidth: '308px',
            '& .MuiSelect-icon': {
              height: '20px',
              width: '20px',
              top: 'calc(50% - 8px)',
            },
          }}
        >
          {options.map((option, index) => (
            <MenuItem key={index} value={option}>
              {withCheckboxes ? (
                <>
                  <Checkbox checked={selectedValues.indexOf(option) > -1} />
                  <ListItemText primary={option} primaryTypographyProps={{ fontSize: '12px' }} />
                </>
              ) : (
                option
              )}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
